
import Vue from 'vue'
import breakpoints from '@/mixins/breakpoints'
import RPHTabButton from 'rph/atoms/RPHTabButton/index.vue'
import { IProductTabs } from 'types/DTO/products'

export default Vue.extend({
  name: 'RPHTabsList',
  components: { RPHTabButton },
  mixins: [breakpoints],
  props: {
    analogsCount: {
      type: Number,
      default: 0,
    },
    reviewsCount: {
      type: Number,
      default: 0,
    },

    type: {
      type: String,
      default: 'main',
    },

    hasRecommendedProducts: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    currentHash(): string {
      return this.$route.hash.slice(1) || 'product'
    },
    productSpecs(): IProductTabs {
      return this.$store.getters['rph-products/annotations']
    },
    haveAnnotations(): boolean {
      return (
        this.productSpecs &&
        Object.values(this.productSpecs).some(
          (item: any) => typeof item?.content === 'string' && item.content.trim() !== '',
        )
      )
    },
    mainTabsData(): any {
      return [
        { id: 1, title: 'Товар', hash: 'product', enabled: true },
        {
          id: 2,
          title: 'Аналоги',
          count: this.analogsCount || 0,
          hash: 'analog',
          enabled: !!this.analogsCount,
        },
        {
          id: 3,
          title: 'Похожие',
          hash: 'similar',
          enabled: !!this.hasRecommendedProducts,
        },
        { id: 4, title: 'Характеристики', hash: 'specifications', enabled: this.screenWidth < 780 },
        { id: 5, title: 'Инструкция', hash: 'manual', enabled: this.haveAnnotations },
        {
          id: 6,
          title: 'Отзывы',
          count: this.reviewsCount || 0,
          hash: 'review',
          enabled: true,
        },
      ]
    },

    manualTabsData(): any {
      return [
        {
          id: 7,
          title: 'Описание',
          hash: 'description',
          enabled: this.productSpecs.description.content.length,
        },
        {
          id: 8,
          title: 'Фармакотерапевтическая группа',
          hash: 'pharmgroup',
          enabled: this.productSpecs.pharmgroup.content.length,
        },
        {
          id: 9,
          title: 'Состав',
          hash: 'composition',
          enabled: this.productSpecs.composition.content.length,
        },
        {
          id: 10,
          title: 'Показания',
          hash: 'use_cases',
          enabled: this.productSpecs.use_cases.content.length,
        },
        {
          id: 11,
          title: 'Передозировка',
          hash: 'overdose',
          enabled: this.productSpecs.overdose.content.length,
        },
        {
          id: 12,
          title: 'Форма выпуска и описание',
          hash: 'releaseform',
          enabled: this.productSpecs.releaseform.content.length,
        },
        {
          id: 13,
          title: 'Особые указания',
          hash: 'specialinstructions',
          enabled: this.productSpecs.specialinstructions.content.length,
        },
        {
          id: 14,
          title: 'Применение',
          hash: 'application',
          enabled: this.productSpecs.applications.content.length,
        },
        {
          id: 15,
          title: 'Противопоказания',
          hash: 'contraindications',
          enabled: this.productSpecs.contraindications.content.length,
        },
        {
          id: 16,
          title: 'Фармакология',
          hash: 'pharmacology',
          enabled: this.productSpecs.pharmacology.content.length,
        },
        {
          id: 17,
          title: 'Взаимодействие',
          hash: 'interaction',
          enabled: this.productSpecs.interaction.content.length,
        },
        {
          id: 18,
          title: 'Побочные действия',
          hash: 'side_effects',
          enabled: this.productSpecs.side_effects.content.length,
        },
        { id: 19, title: 'Статьи', hash: 'articles', enabled: false },
      ]
    },
  },
})
